module.exports = __webpack_public_path__ + "img/mind1.99e45ac8.png";